import { render, staticRenderFns } from "./SingleClaimSummaryCard.vue?vue&type=template&id=9d20303e&scoped=true&lang=pug&"
import script from "./SingleClaimSummaryCard.vue?vue&type=script&lang=js&"
export * from "./SingleClaimSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d20303e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
